// @flow

import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation UpdateRunLogMutation($input: UpdateRunLogInput!) {
    updateRunLog(input: $input) {
      runLog {
        id
        type
        notes
        createdAt
        user {
          ...UserWidget_user
        }
      }
    }
  }
`;

export default {
  commit: createRelayMutation.bind(null, mutation),
};
